/**
 * Highway Jam — baked by ultra_map_editor. Edit via the editor.
 *
 * Do not hand-edit: this file is regenerated wholesale on the next bake, and
 * hand-written comments/formatting do not survive a bake.
 */
import type { WorldData } from '../../types';

export const map: WorldData = {
  cityName: "Highway Jam",
  ground: { width: 130, depth: 60 },
  spawnPoint: { x: -52, z: 0 },
  groundTexture: { textureUrl: "/textures/ground-realistic.webp", textureScale: 0.13, textureRotation: 0.3, secondaryUrl: "/textures/ground-stylized.webp", secondaryScale: 0.09, secondaryRotation: -0.6, noiseUrl: "/textures/noise-detailed.webp", noiseScale: 0.04, noiseRotation: 0.2, noiseOffset: 0.02, noiseGain: 0.85 },

  objects: [
    {
      id: "hw-jam-1",
      kind: "prop",
      label: "Rusted Sedan",
      position: { x: -47.33764478699195, z: -4.226709558235855 },
      size: { w: 3.738, d: 4.972, h: 1.5379 },
      color: 0x6b5a42,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-1.glb",
      collisionW: 3.364,
      collisionD: 4.4748,
      rotationY: 1.571,
      rotationX: 0,
      rotationZ: 0,
      positionY: -0.03811433743489978,
    },
    {
      id: "hw-jam-2",
      kind: "prop",
      label: "Rusted Sedan",
      position: { x: -46.16352413090045, z: 3.2233976265547803 },
      size: { w: 4.4, d: 2.1, h: 1.631 },
      color: 0x6b5a42,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-14.glb",
      collisionW: 3.96,
      collisionD: 1.89,
      rotationY: 3.1708,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "hw-jam-3",
      kind: "prop",
      label: "Rusted Lorry",
      position: { x: -39.72008371813488, z: 3.991406381918172 },
      size: { w: 3.099, d: 7.2, h: 3.38 },
      color: 0x6b5a42,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-46-lorry.glb",
      collisionW: 2.789,
      collisionD: 6.48,
      rotationY: 1.6355753017501558,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "hw-jam-4",
      kind: "prop",
      label: "Rusted Sedan",
      position: { x: -42.69572268190953, z: -4.123788257685729 },
      size: { w: 1.881, d: 4.4, h: 1.352 },
      color: 0x6b5a42,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-17.glb",
      collisionW: 1.693,
      collisionD: 3.96,
      rotationY: 1.59,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "hw-jam-5",
      kind: "prop",
      label: "Rusted Van",
      position: { x: -29, z: -2.42 },
      size: { w: 2.7753, d: 5.72, h: 2.4783 },
      color: 0x6b5a42,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-26-van.glb",
      collisionW: 2.4981,
      collisionD: 5.148,
      rotationY: 1.52,
      positionY: 0,
    },
    {
      id: "hw-jam-6",
      kind: "prop",
      label: "Rusted Sedan",
      position: { x: -36.6744678576478, z: -3.8268798124400214 },
      size: { w: 2.031, d: 4.4, h: 1.464 },
      color: 0x6b5a42,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-3.glb",
      collisionW: 1.828,
      collisionD: 3.96,
      rotationY: 1.63,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "hw-jam-7",
      kind: "prop",
      label: "Abandoned Bus",
      position: { x: -29.78685826275665, z: 4.023365257380782 },
      size: { w: 3.702, d: 11, h: 3.648 },
      color: 0x6b5a42,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-51-bus.glb",
      collisionW: 3.332,
      collisionD: 9.9,
      rotationY: 1.49,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "hw-jam-8",
      kind: "prop",
      label: "Rusted Sedan",
      position: { x: -22.9400934283448, z: -2.7529636482943665 },
      size: { w: 2.2171, d: 4.972, h: 1.6882 },
      color: 0x6b5a42,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-20.glb",
      collisionW: 1.9956,
      collisionD: 4.4748,
      rotationY: 1.66,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "hw-jam-9",
      kind: "prop",
      label: "Rusted Pickup",
      position: { x: -20.448282879101004, z: 5.012410390610761 },
      size: { w: 2.377, d: 5.4, h: 2.029 },
      color: 0x6b5a42,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-62-pickup.glb",
      collisionW: 2.139,
      collisionD: 4.86,
      rotationY: 1.348095112535517,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "hw-jam-10",
      kind: "prop",
      label: "Rusted Sedan",
      position: { x: -18.329915718727076, z: -6.523468796862902 },
      size: { w: 4.972, d: 3.903, h: 1.4893 },
      color: 0x6b5a42,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-5.glb",
      collisionW: 4.4748,
      collisionD: 3.5132,
      rotationY: 3.2908,
      rotationX: 0,
      rotationZ: 0,
      positionY: -0.09626209434035493,
    },
    {
      id: "hw-jam-11",
      kind: "prop",
      label: "Abandoned Taxi",
      position: { x: -8, z: 3.4 },
      size: { w: 2.0329, d: 4.972, h: 1.6882 },
      color: 0x6b5a42,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-48-taxi.glb",
      collisionW: 1.8295,
      collisionD: 4.4748,
      rotationY: 1.34,
      positionY: 0,
    },
    {
      id: "hw-jam-12",
      kind: "prop",
      label: "Rusted Sedan",
      position: { x: -4.5, z: -3.2 },
      size: { w: 1.9827, d: 3.96, h: 1.5534 },
      color: 0x6b5a42,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-31.glb",
      collisionW: 1.7847,
      collisionD: 3.564,
      rotationY: 1.86,
      positionY: 0,
    },
    {
      id: "hw-jam-13",
      kind: "prop",
      label: "Overturned Army Truck",
      position: { x: 1.5646996663972352, z: -2.266354531621409 },
      size: { w: 6.624, d: 3.20068, h: 3.08384 },
      color: 0x6b5a42,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-39-army.glb",
      collisionW: 5.9616,
      collisionD: 2.88052,
      rotationY: 2.294390557263453,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "hw-jam-14",
      kind: "prop",
      label: "Wrecked Cabriolet",
      position: { x: -0.735832614175358, z: 4.657985300365048 },
      size: { w: 1.89, d: 4.2, h: 1.709 },
      color: 0x6b5a42,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-29-cabrio.glb",
      collisionW: 1.701,
      collisionD: 3.78,
      rotationY: 2.016189394044447,
      rotationX: 0,
      rotationZ: 0,
      positionY: -0.4714970255148452,
    },
    {
      id: "hw-jam-15",
      kind: "prop",
      label: "Wrecked Sedan",
      position: { x: 7.483164006751245, z: -2.807952590489672 },
      size: { w: 1.859, d: 4.4, h: 1.408 },
      color: 0x6b5a42,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-36.glb",
      collisionW: 1.673,
      collisionD: 3.96,
      rotationY: 2.0746504383263806,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "hw-jam-16",
      kind: "prop",
      label: "Rusted Army Truck",
      position: { x: 52.481133773668866, z: 7.733951487854311 },
      size: { w: 3.056, d: 7.2, h: 2.81 },
      color: 0x6b5a42,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-45-army.glb",
      collisionW: 2.75,
      collisionD: 6.48,
      rotationY: 1.2727846988299696,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "hw-jam-17",
      kind: "prop",
      label: "Rusted Sedan",
      position: { x: 44.281168093213836, z: 6.3867555248284145 },
      size: { w: 2.491, d: 4.4, h: 1.683 },
      color: 0x6b5a42,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-59.glb",
      collisionW: 2.242,
      collisionD: 3.96,
      rotationY: 1.3030372346389212,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "hw-jam-18",
      kind: "prop",
      label: "Stripped Shell",
      position: { x: 24, z: 3.2 },
      size: { w: 4.998, d: 6.16, h: 1.9768 },
      color: 0x6b5a42,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-2-hood.glb",
      collisionW: 4.4982,
      collisionD: 5.544,
      rotationY: 1.57,
      positionY: 0,
    },
    {
      id: "hw-jam-19",
      kind: "prop",
      label: "Rusted Sedan",
      position: { x: 52.3195665229743, z: -0.8945708306229427 },
      size: { w: 2.0182, d: 4.972, h: 1.3842 },
      color: 0x6b5a42,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-55.glb",
      collisionW: 1.8159,
      collisionD: 4.4748,
      rotationY: 1.17775868198278,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "hw-jam-20",
      kind: "prop",
      label: "Rusted Sedan",
      position: { x: 47.967164092156594, z: -1.751039125481637 },
      size: { w: 3.74, d: 1.887, h: 1.4161 },
      color: 0x6b5a42,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-9.glb",
      collisionW: 3.366,
      collisionD: 1.6983,
      rotationY: 3.1208,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "hw-jam-21",
      kind: "prop",
      label: "Abandoned Ambulance",
      position: { x: 54.37871174965258, z: -2.4506694621056715 },
      size: { w: 2.177, d: 5.2, h: 2.436 },
      color: 0x6b5a42,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-57-ambulance.glb",
      collisionW: 1.959,
      collisionD: 4.68,
      rotationY: 0.904103217024168,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "hw-jam-22",
      kind: "prop",
      label: "Rusted Sedan",
      position: { x: 49.223807889206256, z: 2.872555406655916 },
      size: { w: 4.4, d: 1.877, h: 1.447 },
      color: 0x6b5a42,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-11.glb",
      collisionW: 3.96,
      collisionD: 1.689,
      rotationY: -2.808351698906132,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "hw-barrier-1-n",
      kind: "prop",
      label: "Crash Barrier",
      position: { x: -46.356, z: -9.4189 },
      size: { w: 7.04, d: 1.54, h: 2.2 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-wall.glb",
      rotationY: 1.5707963267948966,
    },
    {
      id: "hw-barrier-1-s",
      kind: "prop",
      label: "Crash Barrier",
      position: { x: -45.9739, z: 7.6989 },
      size: { w: 7.04, d: 1.54, h: 2.2 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-wall.glb",
      rotationY: 1.5707963267948966,
    },
    {
      id: "hw-barrier-2-n",
      kind: "prop",
      label: "Crash Barrier",
      position: { x: -39.9, z: -7.4 },
      size: { w: 7.04, d: 1.54, h: 2.2 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-barrier.glb",
      rotationY: 1.5707963267948966,
    },
    {
      id: "hw-barrier-2-s",
      kind: "prop",
      label: "Crash Barrier",
      position: { x: -39.8649, z: 8.9441 },
      size: { w: 7.04, d: 1.54, h: 2.2 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-barrier.glb",
      rotationY: 1.5707963267948966,
    },
    {
      id: "hw-barrier-3-n",
      kind: "prop",
      label: "Crash Barrier",
      position: { x: -33.85, z: -7.4 },
      size: { w: 7.04, d: 1.54, h: 2.2 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-barrier.glb",
      rotationY: 1.5707963267948966,
    },
    {
      id: "hw-barrier-3-s",
      kind: "prop",
      label: "Crash Barrier",
      position: { x: -35.4972, z: 7.8012 },
      size: { w: 7.04, d: 1.54, h: 2.2 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-barrier.glb",
      rotationY: 1.5707963267948966,
    },
    {
      id: "hw-barrier-4-n",
      kind: "prop",
      label: "Crash Barrier",
      position: { x: -28.0433, z: -7.425 },
      size: { w: 7.04, d: 1.54, h: 2.2 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-wall.glb",
      rotationY: 1.5707963267948966,
    },
    {
      id: "hw-barrier-4-s",
      kind: "prop",
      label: "Crash Barrier",
      position: { x: -27.5471, z: 9.0904 },
      size: { w: 7.04, d: 1.54, h: 2.2 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-wall.glb",
      rotationY: 1.5707963267948966,
    },
    {
      id: "hw-barrier-5-n",
      kind: "prop",
      label: "Crash Barrier",
      position: { x: 8.25, z: -7.4 },
      size: { w: 7.04, d: 1.54, h: 2.2 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-barrier.glb",
      rotationY: 1.5707963267948966,
    },
    {
      id: "hw-barrier-5-s",
      kind: "prop",
      label: "Crash Barrier",
      position: { x: 3.8702, z: 8.3932 },
      size: { w: 7.04, d: 1.54, h: 2.2 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-barrier.glb",
      rotationY: 1.5707963267948966,
    },
    {
      id: "hw-barrier-6-n",
      kind: "prop",
      label: "Crash Barrier",
      position: { x: 12, z: -7.4 },
      size: { w: 7.04, d: 1.54, h: 2.2 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-barrier.glb",
      rotationY: 1.5707963267948966,
    },
    {
      id: "hw-barrier-6-s",
      kind: "prop",
      label: "Crash Barrier",
      position: { x: 15.5, z: 7.4 },
      size: { w: 7.04, d: 1.54, h: 2.2 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-barrier.glb",
      rotationY: 1.5707963267948966,
    },
    {
      id: "hw-barrier-7-n",
      kind: "prop",
      label: "Crash Barrier",
      position: { x: 16.6, z: -7.4 },
      size: { w: 7.04, d: 1.54, h: 2.2 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-wall.glb",
      rotationY: 1.5707963267948966,
    },
    {
      id: "hw-barrier-7-s",
      kind: "prop",
      label: "Crash Barrier",
      position: { x: 18, z: 7.4 },
      size: { w: 7.04, d: 1.54, h: 2.2 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-wall.glb",
      rotationY: 1.5707963267948966,
    },
    {
      id: "hw-barrier-8-n",
      kind: "prop",
      label: "Crash Barrier",
      position: { x: 24, z: -7.4 },
      size: { w: 7.04, d: 1.54, h: 2.2 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-barrier.glb",
      rotationY: 1.5707963267948966,
    },
    {
      id: "hw-barrier-8-s",
      kind: "prop",
      label: "Crash Barrier",
      position: { x: 24.2222, z: 9.9403 },
      size: { w: 7.04, d: 1.54, h: 2.2 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-barrier.glb",
      rotationY: 1.5707963267948966,
    },
    {
      id: "hw-barrier-9-n",
      kind: "prop",
      label: "Crash Barrier",
      position: { x: 36, z: -7.4 },
      size: { w: 7.04, d: 1.54, h: 2.2 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-barrier.glb",
      rotationY: 1.5707963267948966,
    },
    {
      id: "hw-barrier-9-s",
      kind: "prop",
      label: "Crash Barrier",
      position: { x: 36.0959, z: 8.4958 },
      size: { w: 7.04, d: 1.54, h: 2.2 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-barrier.glb",
      rotationY: 1.5707963267948966,
    },
    {
      id: "hw-barrier-10-n",
      kind: "prop",
      label: "Crash Barrier",
      position: { x: 47.08, z: -6.651 },
      size: { w: 7.04, d: 1.54, h: 2.2 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-wall.glb",
      rotationY: 1.5707963267948966,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "hw-barrier-10-s",
      kind: "prop",
      label: "Crash Barrier",
      position: { x: 41.2723, z: 8.0106 },
      size: { w: 7.04, d: 1.54, h: 2.2 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-wall.glb",
      rotationY: 1.5707963267948966,
    },
    {
      id: "hw-camp-bus",
      kind: "prop",
      label: "Camp Windbreak",
      position: { x: 6.5, z: -22.5 },
      size: { w: 11, d: 2.6, h: 3 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-49-bus.glb",
      rotationY: 0.35,
    },
    {
      id: "hw-camp-shack-1",
      kind: "building",
      label: "Lean-to",
      position: { x: 20.5, z: -23 },
      size: { w: 5, d: 4.6, h: 3 },
      color: 0x6a5c4a,
      interactable: false,
      modelUrl: "/models/buildings/building_shack_wooden.glb",
      rotationY: -0.5,
    },
    {
      id: "hw-camp-shack-2",
      kind: "building",
      label: "Bandit Shelter",
      position: { x: 15, z: -26.5 },
      size: { w: 5.2, d: 4.8, h: 3.4 },
      color: 0x6a5c4a,
      interactable: false,
      modelUrl: "/models/buildings/building_shack_c.glb",
      rotationY: 0.18,
    },
    {
      id: "hw-camp-fire",
      kind: "prop",
      label: "Camp Fire",
      position: { x: 14, z: -19 },
      size: { w: 3.4, d: 3.4, h: 1.7 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_campfire-pit.glb",
      rotationY: 0,
    },
    {
      id: "hw-camp-bell",
      kind: "prop",
      label: "Alarm Bell",
      position: { x: 10.6, z: -15.4 },
      size: { w: 0.7, d: 0.7, h: 2.2 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_bell-camp.glb",
      rotationY: 1.1,
    },
    {
      id: "hw-camp-lantern",
      kind: "prop",
      label: "Oil Lantern",
      position: { x: 17.2, z: -17.8 },
      size: { w: 0.3, d: 0.3, h: 0.4 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_lantern-oil.glb",
      rotationY: 0,
      noClip: true,
    },
    {
      id: "hw-camp-bed-1",
      kind: "prop",
      label: "Bedroll",
      position: { x: 15.70348892446148, z: -16.57399946337045 },
      size: { w: 2, d: 0.9, h: 0.35 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_sleeping-bag.glb",
      rotationY: 3.741592653589793,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "hw-camp-bed-2",
      kind: "prop",
      label: "Bedroll",
      position: { x: 16.161482177763684, z: -21.359659889731986 },
      size: { w: 2, d: 0.9, h: 0.35 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_sleeping-bag.glb",
      rotationY: 5.5415926535897935,
      noClip: true,
    },
    {
      id: "hw-camp-bed-3",
      kind: "prop",
      label: "Bedroll",
      position: { x: 11.210957528276518, z: -20.56883462829024 },
      size: { w: 2, d: 0.9, h: 0.35 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_sleeping-bag.glb",
      rotationY: 7.341592653589793,
      noClip: true,
    },
    {
      id: "hw-camp-sandbag-1",
      kind: "prop",
      label: "Sandbag Wall",
      position: { x: 9.5, z: -12.6 },
      size: { w: 2.6, d: 0.9, h: 1 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 1.5707963267948966,
    },
    {
      id: "hw-camp-sandbag-3",
      kind: "prop",
      label: "Sandbag Wall",
      position: { x: 17.147673220098135, z: -11.880694662669098 },
      size: { w: 2.6, d: 0.9, h: 1 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: -2.3405960479978543,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "hw-sign-1",
      kind: "prop",
      label: "Highway Sign",
      position: { x: -25, z: -9.6 },
      size: { w: 2.6, d: 0.4, h: 4.4 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_sign-2.glb",
      rotationY: 1.571,
    },
    {
      id: "hw-sign-2",
      kind: "prop",
      label: "Highway Sign",
      position: { x: 27, z: 9.6 },
      size: { w: 2.4, d: 0.4, h: 4 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_sign.glb",
      rotationY: -1.571,
    },
    {
      id: "hw-tree-1",
      kind: "prop",
      label: "Dead Tree",
      position: { x: -18, z: 14 },
      size: { w: 1.4, d: 1.4, h: 5.2 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_tree-broken-1.glb",
      rotationY: 0.9,
    },
    {
      id: "hw-tree-2",
      kind: "prop",
      label: "Stump",
      position: { x: 44.998730626123276, z: -8.730674180948235 },
      size: { w: 1.6, d: 1.6, h: 1.2 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: -0.4,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "hw-trailer",
      kind: "prop",
      label: "Jackknifed Tanker",
      position: { x: -5, z: -12.5 },
      size: { w: 9.5, d: 2.6, h: 3.4 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_trailer-tanker.glb",
      rotationY: 1.25,
    },
    {
      id: "hw-tyres",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: 21, z: 11.5 },
      size: { w: 1.4, d: 1.4, h: 1.1 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 0.5,
    },
    {
      id: "hw-loot-1",
      kind: "loot",
      label: "Wooden Crate",
      position: { x: -32, z: -10.5 },
      size: { w: 1, d: 1, h: 0.9 },
      color: 0x8a6a34,
      interactable: true,
      lootObjectId: "highway-1",
      modelUrl: "/models/objects/obj_crate-wood.glb",
      rotationY: 0,
    },
    {
      id: "hw-loot-2",
      kind: "loot",
      label: "Barrel",
      position: { x: -12, z: 10.5 },
      size: { w: 0.7, d: 0.7, h: 1 },
      color: 0x8a6a34,
      interactable: true,
      lootObjectId: "highway-2",
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 0.9,
    },
    {
      id: "hw-loot-3",
      kind: "loot",
      label: "Toolbox",
      position: { x: 4.5, z: -8.5 },
      size: { w: 0.8, d: 0.5, h: 0.5 },
      color: 0x8a6a34,
      interactable: true,
      lootObjectId: "highway-3",
      modelUrl: "/models/objects/obj_toolbox.glb",
      rotationY: 1.8,
    },
    {
      id: "hw-loot-4",
      kind: "loot",
      label: "Crate Stack",
      position: { x: 28.7, z: 10.5 },
      size: { w: 1.6, d: 1.4, h: 1.4 },
      color: 0x8a6a34,
      interactable: true,
      lootObjectId: "highway-4",
      modelUrl: "/models/objects/obj_crates-2.glb",
      rotationY: 2.7,
    },
    {
      id: "hw-loot-5",
      kind: "loot",
      label: "Bandit Stash",
      position: { x: 17.5765, z: -19.9628 },
      size: { w: 1.6, d: 1.4, h: 1.4 },
      color: 0x8a6a34,
      interactable: true,
      lootObjectId: "highway-5",
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 0.458407346410207,
    },
    {
      id: "hw-loot-6",
      kind: "loot",
      label: "Looted Barrel",
      position: { x: 10.1553, z: -23.5796 },
      size: { w: 0.7, d: 0.7, h: 0.6 },
      color: 0x8a6a34,
      interactable: true,
      lootObjectId: "highway-6",
      modelUrl: "/models/objects/obj_barrel-half.glb",
      rotationY: 1.3584073464102069,
    },
    {
      id: "hw-loot-7",
      kind: "loot",
      label: "Burlap Sack",
      position: { x: 15.6394, z: -22.9061 },
      size: { w: 0.8, d: 0.8, h: 0.7 },
      color: 0x8a6a34,
      interactable: true,
      lootObjectId: "highway-7",
      modelUrl: "/models/objects/obj_sack-burlap.glb",
      rotationY: 2.2584073464102072,
    },
    {
      id: "object-mtx2jg3y",
      kind: "prop",
      label: "Jersey-wall",
      position: { x: 60.8169, z: 0.1158 },
      size: { w: 2.1582, d: 7.139, h: 1.782 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-wall.glb",
      rotationY: -0.01790903870771678,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "object-mtx2jrp2",
      kind: "prop",
      label: "Jersey-wall",
      position: { x: 60.5704, z: 7.2941 },
      size: { w: 2.1582, d: 7.139, h: 1.782 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-wall.glb",
      rotationY: 0,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "object-mtx2jy3n",
      kind: "prop",
      label: "Jersey-wall",
      position: { x: 59.5244, z: -7.0065 },
      size: { w: 2.1582, d: 7.139, h: 1.782 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-wall.glb",
      rotationY: 0,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "object-mtx2k301",
      kind: "prop",
      label: "Jersey-wall",
      position: { x: 58.40207503952641, z: 4.543747712360521 },
      size: { w: 2.1582, d: 7.139, h: 1.782 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-wall.glb",
      rotationY: 0,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "object-mtx2k799",
      kind: "prop",
      label: "Jersey-barrier",
      position: { x: 53.291, z: -5.8813 },
      size: { w: 1.815, d: 4.6948, h: 1.782 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-barrier.glb",
      rotationY: 0,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "object-mtx2kcgr",
      kind: "prop",
      label: "Jersey-barrier",
      position: { x: 57.1651, z: -6.3899 },
      size: { w: 1.815, d: 4.6948, h: 1.782 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-barrier.glb",
      rotationY: 0.1163020447325092,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "object-mtx2kgon",
      kind: "prop",
      label: "Jersey-barrier",
      position: { x: 53.467, z: 2.3328 },
      size: { w: 1.815, d: 4.6948, h: 1.782 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-barrier.glb",
      rotationY: 0,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "object-mtx2kpoq",
      kind: "prop",
      label: "Jersey-barrier",
      position: { x: 56.4236, z: 4.2283 },
      size: { w: 1.815, d: 4.6948, h: 1.782 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-barrier.glb",
      rotationY: 0,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "object-mtx2nzvq",
      kind: "prop",
      label: "Car-rust-33-van",
      position: { x: 44.292834848492454, z: -2.817172310745404 },
      size: { w: 3.9987, d: 2.0961, h: 1.881 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-33-van.glb",
      rotationY: -0.39035457081913044,
      rotationX: -3.141592653589793,
      rotationZ: -3.141592653589793,
      positionY: 0,
    },
    {
      id: "object-mtx2pzl6",
      kind: "prop",
      label: "Car-rust-42-flatbed",
      position: { x: 42.89346944913459, z: 2.914206260071314 },
      size: { w: 2.9798, d: 5.8138, h: 2.599 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-42-flatbed.glb",
      rotationY: 1.5302736111322888,
      rotationX: -3.141592653589793,
      rotationZ: -3.141592653589793,
      positionY: 0,
    },
    {
      id: "object-mtx2qpcw",
      kind: "prop",
      label: "Car-rust-12",
      position: { x: 39.66418639401833, z: -3.2830185202346343 },
      size: { w: 4.617, d: 1.956, h: 1.5 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-12.glb",
      rotationY: -0.18103519611713004,
      rotationX: -3.141592653589793,
      rotationZ: -3.141592653589793,
      positionY: 0,
    },
    {
      id: "object-mtx2r66g",
      kind: "prop",
      label: "Car-rust-13-suv",
      position: { x: 37.055415937516074, z: 3.596734055864177 },
      size: { w: 2.2202, d: 4.4353, h: 2.975 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-13-suv.glb",
      rotationY: 1.519427362613026,
      rotationX: 0,
      rotationZ: 0,
      positionY: -0.588983,
    },
    {
      id: "object-mtx2sfs3",
      kind: "prop",
      label: "Car-rust-19",
      position: { x: 37.39098219342292, z: -1.4132114038164065 },
      size: { w: 4.645, d: 2.036, h: 1.5 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-19.glb",
      rotationY: 0.10549939861268987,
      rotationX: -3.141592653589793,
      rotationZ: -3.141592653589793,
      positionY: 0,
    },
    {
      id: "object-mtx2st1e",
      kind: "prop",
      label: "Car-rust-22",
      position: { x: 32.655043137618556, z: -3.2378618477918266 },
      size: { w: 4.393, d: 2.006, h: 1.5 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-22.glb",
      rotationY: 1.3352354249866907,
      rotationX: -3.141592653589793,
      rotationZ: -3.141592653589793,
      positionY: 0,
    },
    {
      id: "object-mtx2t4vb",
      kind: "prop",
      label: "Car-rust-26-van",
      position: { x: 29.169237955233896, z: -1.5556950998776191 },
      size: { w: 2.3771, d: 4.8994, h: 2.123 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-26-van.glb",
      rotationY: 1.4809608005231447,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "object-mtx2wjqd",
      kind: "prop",
      label: "Car-rust-61-semi",
      position: { x: 9.269940859126926, z: 4.552961597889195 },
      size: { w: 7.31595, d: 8.54335, h: 3.61 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-61-semi.glb",
      rotationY: 1.260711839311534,
      rotationX: -3.141592653589793,
      rotationZ: -3.141592653589793,
      positionY: 0,
    },
    {
      id: "object-mtx2xvc7",
      kind: "prop",
      label: "Car-rust-67-firefighter",
      position: { x: 23.847285845386644, z: -1.5173540914520878 },
      size: { w: 2.34646, d: 4.66739, h: 2.392 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-67-firefighter.glb",
      rotationY: 1.505229999623278,
      rotationX: -1.224646799147353e-16,
      rotationZ: 1.2246467991473535e-16,
      positionY: 0,
    },
    {
      id: "object-mtx2zfbv",
      kind: "prop",
      label: "Car-rust-4",
      position: { x: 20.107338029847117, z: -8.961829703836107 },
      size: { w: 4.576, d: 3.293, h: 1.5 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-4.glb",
      rotationY: -0.39096182565336907,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "object-mtx307e1",
      kind: "prop",
      label: "Bike_bobber",
      position: { x: 5.860104335448779, z: -6.15 },
      size: { w: 2.888, d: 1.76, h: 1.15 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_bike_bobber.glb",
      rotationY: 0.27871207028195644,
      rotationX: -3.141592653589793,
      rotationZ: -3.141592653589793,
      positionY: -0.05877187214633661,
    },
    {
      id: "object-mtx3175z",
      kind: "prop",
      label: "Carseat",
      position: { x: 16.91430354194568, z: -18.46754426426143 },
      size: { w: 0.673, d: 0.936, h: 1.0924999999999998 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_carseat.glb",
      rotationY: -0.8061424936898949,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "infill-highway_jam-1",
      kind: "prop",
      label: "Sandbags",
      position: { x: -4.975, z: -20.412 },
      size: { w: 1.672, d: 0.243, h: 0.228 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 1.475,
    },
    {
      id: "infill-highway_jam-3",
      kind: "prop",
      label: "Pallet Stack",
      position: { x: -11.414, z: 13.374 },
      size: { w: 1.549, d: 0.886, h: 0.783 },
      color: 0x6f5c3e,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 5.595,
    },
    {
      id: "infill-highway_jam-4",
      kind: "prop",
      label: "Cable Spool",
      position: { x: 17.82, z: -3.599 },
      size: { w: 0.473, d: 0.399, h: 0.345 },
      color: 0x5a4d38,
      interactable: false,
      modelUrl: "/models/objects/obj_rope-coil.glb",
      rotationY: 0.969,
      noClip: true,
    },
    {
      id: "infill-highway_jam-5",
      kind: "prop",
      label: "Barrel",
      position: { x: -10.435, z: 11.445 },
      size: { w: 0.629, d: 0.629, h: 0.844 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 0.6,
    },
    {
      id: "infill-highway_jam-6",
      kind: "prop",
      label: "Crates",
      position: { x: -1.581, z: 19.422 },
      size: { w: 1.627, d: 1.549, h: 0.894 },
      color: 0x7a6544,
      interactable: false,
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 3.002,
    },
    {
      id: "infill-highway_jam-7",
      kind: "prop",
      label: "Pallet Stack",
      position: { x: 7.891, z: 22.939 },
      size: { w: 1.426, d: 0.815, h: 0.721 },
      color: 0x6f5c3e,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 4.146,
    },
    {
      id: "infill-highway_jam-8",
      kind: "prop",
      label: "Cable Spool",
      position: { x: -4.513, z: -21.983 },
      size: { w: 0.524, d: 0.442, h: 0.382 },
      color: 0x5a4d38,
      interactable: false,
      modelUrl: "/models/objects/obj_rope-coil.glb",
      rotationY: 1.793,
      noClip: true,
    },
    {
      id: "infill-highway_jam-9",
      kind: "prop",
      label: "Half Barrel",
      position: { x: 14.978, z: -2.218 },
      size: { w: 0.606, d: 0.578, h: 0.553 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel-half.glb",
      rotationY: 5.444,
    },
    {
      id: "infill-highway_jam-10",
      kind: "prop",
      label: "Barrel",
      position: { x: 1.567, z: -13.421 },
      size: { w: 0.78, d: 0.78, h: 1.046 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 1.205,
    },
    {
      id: "infill-highway_jam-11",
      kind: "prop",
      label: "Pallet Stack",
      position: { x: -7.587, z: -3.16 },
      size: { w: 1.59, d: 0.909, h: 0.804 },
      color: 0x6f5c3e,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 0.961,
    },
    {
      id: "infill-highway_jam-12",
      kind: "prop",
      label: "Crates",
      position: { x: -13.556, z: 11.975 },
      size: { w: 1.379, d: 1.313, h: 0.758 },
      color: 0x7a6544,
      interactable: false,
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 3.766,
    },
    {
      id: "infill-highway_jam-13",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: 0.229, z: -16.285 },
      size: { w: 2.119, d: 1.914, h: 0.897 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 2.926,
    },
    {
      id: "infill-highway_jam-14",
      kind: "prop",
      label: "Dumpster",
      position: { x: -11.525, z: 1.307 },
      size: { w: 1.818, d: 1.445, h: 1.301 },
      color: 0x3f5546,
      interactable: false,
      modelUrl: "/models/objects/obj_dumpster.glb",
      rotationY: 4.476,
    },
    {
      id: "infill-highway_jam-15",
      kind: "prop",
      label: "Half Barrel",
      position: { x: -17.653, z: 15.72 },
      size: { w: 0.501, d: 0.478, h: 0.457 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel-half.glb",
      rotationY: 5.36,
    },
    {
      id: "infill-highway_jam-17",
      kind: "prop",
      label: "Cable Spool",
      position: { x: -19.481, z: 12.339 },
      size: { w: 0.503, d: 0.424, h: 0.367 },
      color: 0x5a4d38,
      interactable: false,
      modelUrl: "/models/objects/obj_rope-coil.glb",
      rotationY: 1.979,
      noClip: true,
    },
    {
      id: "infill-highway_jam-18",
      kind: "prop",
      label: "Jersey Barrier",
      position: { x: -14.865, z: 5.886 },
      size: { w: 0.819, d: 2.12, h: 0.805 },
      color: 0x8a8578,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-barrier.glb",
      rotationY: 1.53,
    },
    {
      id: "infill-highway_jam-19",
      kind: "prop",
      label: "Barrel",
      position: { x: -20.358, z: 1.562 },
      size: { w: 0.776, d: 0.776, h: 1.042 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 1.383,
    },
    {
      id: "infill-highway_jam-20",
      kind: "prop",
      label: "Barrel",
      position: { x: -14.325, z: -20.091 },
      size: { w: 0.588, d: 0.588, h: 0.789 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 3.399,
    },
    {
      id: "infill-highway_jam-21",
      kind: "prop",
      label: "Pallet Stack",
      position: { x: -2.378, z: 10.444 },
      size: { w: 1.328, d: 0.759, h: 0.671 },
      color: 0x6f5c3e,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 5.468,
    },
    {
      id: "infill-highway_jam-22",
      kind: "prop",
      label: "Half Barrel",
      position: { x: -8.155, z: -4.259 },
      size: { w: 0.494, d: 0.471, h: 0.451 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel-half.glb",
      rotationY: 4.323,
    },
    {
      id: "infill-highway_jam-23",
      kind: "prop",
      label: "Crates",
      position: { x: -1.643, z: 7.901 },
      size: { w: 1.179, d: 1.123, h: 0.648 },
      color: 0x7a6544,
      interactable: false,
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 1.797,
    },
    {
      id: "infill-highway_jam-24",
      kind: "prop",
      label: "Dumpster",
      position: { x: 13.441, z: 20.828 },
      size: { w: 1.788, d: 1.421, h: 1.28 },
      color: 0x3f5546,
      interactable: false,
      modelUrl: "/models/objects/obj_dumpster.glb",
      rotationY: 2.284,
    },
    {
      id: "infill-highway_jam-25",
      kind: "prop",
      label: "Barrel",
      position: { x: 14.584, z: -12.252 },
      size: { w: 0.714, d: 0.714, h: 0.958 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 1.898,
    },
    {
      id: "infill-highway_jam-26",
      kind: "prop",
      label: "Crates",
      position: { x: -1.861, z: -24.857 },
      size: { w: 1.161, d: 1.106, h: 0.638 },
      color: 0x7a6544,
      interactable: false,
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 2.091,
    },
    {
      id: "infill-highway_jam-27",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: -7.013, z: -21.949 },
      size: { w: 2.287, d: 2.066, h: 0.969 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 3.833,
    },
    {
      id: "infill-highway_jam-28",
      kind: "prop",
      label: "Crates",
      position: { x: 16.698, z: 13.273 },
      size: { w: 1.414, d: 1.347, h: 0.777 },
      color: 0x7a6544,
      interactable: false,
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 5.124,
    },
    {
      id: "infill-highway_jam-29",
      kind: "prop",
      label: "Half Barrel",
      position: { x: -14.594, z: -6.67 },
      size: { w: 0.584, d: 0.557, h: 0.533 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel-half.glb",
      rotationY: 5.207,
    },
    {
      id: "infill-highway_jam-30",
      kind: "prop",
      label: "Barrel",
      position: { x: 13.679, z: 2.377 },
      size: { w: 0.789, d: 0.789, h: 1.059 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 4.179,
    },
    {
      id: "infill-highway_jam-31",
      kind: "prop",
      label: "Crates",
      position: { x: -6.004, z: -19.198 },
      size: { w: 1.484, d: 1.413, h: 0.816 },
      color: 0x7a6544,
      interactable: false,
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 1.275,
    },
    {
      id: "infill-highway_jam-32",
      kind: "prop",
      label: "Sandbags",
      position: { x: -8.451, z: 9.197 },
      size: { w: 1.67, d: 0.242, h: 0.228 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 3.155,
    },
    {
      id: "infill-highway_jam-33",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: -5.11, z: 9.425 },
      size: { w: 2.064, d: 1.865, h: 0.874 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 3.144,
    },
    {
      id: "infill-highway_jam-34",
      kind: "prop",
      label: "Pallet Stack",
      position: { x: 2.454, z: 15.875 },
      size: { w: 1.515, d: 0.866, h: 0.766 },
      color: 0x6f5c3e,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 1.489,
    },
    {
      id: "infill-highway_jam-35",
      kind: "prop",
      label: "Cable Spool",
      position: { x: 16.336, z: 3.355 },
      size: { w: 0.466, d: 0.393, h: 0.34 },
      color: 0x5a4d38,
      interactable: false,
      modelUrl: "/models/objects/obj_rope-coil.glb",
      rotationY: 2.51,
      noClip: true,
    },
    {
      id: "infill-highway_jam-36",
      kind: "prop",
      label: "Dumpster",
      position: { x: -14.581, z: 16.26 },
      size: { w: 2.064, d: 1.64, h: 1.477 },
      color: 0x3f5546,
      interactable: false,
      modelUrl: "/models/objects/obj_dumpster.glb",
      rotationY: 0.358,
    },
    {
      id: "infill-highway_jam-37",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: -13.658, z: 20.719 },
      size: { w: 2.421, d: 2.187, h: 1.025 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 2.176,
    },
    {
      id: "infill-highway_jam-38",
      kind: "prop",
      label: "Pallet Stack",
      position: { x: -9.689, z: 14.801 },
      size: { w: 1.322, d: 0.756, h: 0.669 },
      color: 0x6f5c3e,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 2.717,
    },
    {
      id: "infill-highway_jam-39",
      kind: "prop",
      label: "Dumpster",
      position: { x: -17.951, z: 1.744 },
      size: { w: 2.252, d: 1.79, h: 1.611 },
      color: 0x3f5546,
      interactable: false,
      modelUrl: "/models/objects/obj_dumpster.glb",
      rotationY: 1.263,
    },
    {
      id: "infill-highway_jam-40",
      kind: "prop",
      label: "Cable Spool",
      position: { x: -8.445, z: -1.787 },
      size: { w: 0.542, d: 0.457, h: 0.396 },
      color: 0x5a4d38,
      interactable: false,
      modelUrl: "/models/objects/obj_rope-coil.glb",
      rotationY: 2.964,
      noClip: true,
    },
    {
      id: "infill-highway_jam-41",
      kind: "prop",
      label: "Barrel",
      position: { x: -16.713, z: -17.037 },
      size: { w: 0.634, d: 0.634, h: 0.851 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 1.639,
    },
    {
      id: "infill-highway_jam-42",
      kind: "prop",
      label: "Dumpster",
      position: { x: -15.965, z: -10.186 },
      size: { w: 2.443, d: 1.942, h: 1.748 },
      color: 0x3f5546,
      interactable: false,
      modelUrl: "/models/objects/obj_dumpster.glb",
      rotationY: 4.918,
    },
    {
      id: "infill-highway_jam-43",
      kind: "prop",
      label: "Barrel",
      position: { x: -19.551, z: 14.74 },
      size: { w: 0.726, d: 0.726, h: 0.975 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 2.712,
    },
    {
      id: "infill-highway_jam-44",
      kind: "prop",
      label: "Half Barrel",
      position: { x: 18.811, z: 2.04 },
      size: { w: 0.615, d: 0.586, h: 0.561 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel-half.glb",
      rotationY: 4.032,
    },
    {
      id: "infill-highway_jam-45",
      kind: "prop",
      label: "Barrel",
      position: { x: 16.512, z: 0.248 },
      size: { w: 0.585, d: 0.585, h: 0.785 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 2.68,
    },
    {
      id: "infill-highway_jam-46",
      kind: "prop",
      label: "Half Barrel",
      position: { x: -1.5, z: 23.836 },
      size: { w: 0.51, d: 0.486, h: 0.465 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel-half.glb",
      rotationY: 3.662,
    },
    {
      id: "infill-highway_jam-47",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: -2.297, z: -17.751 },
      size: { w: 1.948, d: 1.76, h: 0.825 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 3.379,
    },
    {
      id: "infill-highway_jam-48",
      kind: "prop",
      label: "Barrel",
      position: { x: -11.173, z: -9.359 },
      size: { w: 0.6, d: 0.6, h: 0.805 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 1.857,
    },
    {
      id: "infill-highway_jam-49",
      kind: "prop",
      label: "Crates",
      position: { x: 1.126, z: -19.534 },
      size: { w: 1.252, d: 1.192, h: 0.688 },
      color: 0x7a6544,
      interactable: false,
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 3.819,
    },
    {
      id: "infill-highway_jam-50",
      kind: "prop",
      label: "Half Barrel",
      position: { x: -12.622, z: -19.153 },
      size: { w: 0.54, d: 0.515, h: 0.493 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel-half.glb",
      rotationY: 0.385,
    },
    {
      id: "infill-highway_jam-51",
      kind: "prop",
      label: "Pallet Stack",
      position: { x: 2.575, z: -12.229 },
      size: { w: 1.364, d: 0.78, h: 0.69 },
      color: 0x6f5c3e,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 2.312,
    },
    {
      id: "infill-highway_jam-52",
      kind: "prop",
      label: "Sandbags",
      position: { x: -0.671, z: 11.814 },
      size: { w: 2.085, d: 0.302, h: 0.284 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 3.562,
    },
    {
      id: "infill-highway_jam-53",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: -12.327, z: 6.743 },
      size: { w: 2.12, d: 1.915, h: 0.898 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 0.906,
    },
    {
      id: "infill-highway_jam-54",
      kind: "prop",
      label: "Dumpster",
      position: { x: 7.134, z: -13.817 },
      size: { w: 2.009, d: 1.597, h: 1.438 },
      color: 0x3f5546,
      interactable: false,
      modelUrl: "/models/objects/obj_dumpster.glb",
      rotationY: 5.754,
    },
    {
      id: "infill-highway_jam-55",
      kind: "prop",
      label: "Pallet Stack",
      position: { x: 11.637, z: -2.263 },
      size: { w: 1.731, d: 0.99, h: 0.875 },
      color: 0x6f5c3e,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 5.867,
    },
  ],

  collisionZones: [
    {
      id: "hw-fog-w",
      label: "West Haze",
      position: { x: -60, z: 0 },
      size: { w: 10, d: 56 },
      fog: { color: 10134438, opacity: 0.4, height: 3.2 },
    },
    {
      id: "hw-fog-e",
      label: "East Haze",
      position: { x: 60, z: 0 },
      size: { w: 10, d: 56 },
      fog: { color: 10134438, opacity: 0.4, height: 3.2 },
    },
    {
      id: "hw-fog-n",
      label: "North Field",
      position: { x: 0, z: -26 },
      size: { w: 120, d: 8 },
      fog: { color: 10134438, opacity: 0.26, height: 3.2 },
    },
    {
      id: "hw-fog-s",
      label: "South Field",
      position: { x: 0, z: 26 },
      size: { w: 120, d: 8 },
      fog: { color: 10134438, opacity: 0.26, height: 3.2 },
    },
  ],

  roads: [
    {
      id: "hw-main",
      label: "The Highway",
      surface: "asphalt_old",
      points: [{ x: -64, z: 0 }, { x: -10, z: 0.3 }, { x: 20, z: -0.4 }, { x: 64, z: 0 }],
      width: 12,
    },
    {
      id: "hw-slip",
      label: "Camp Track",
      surface: "dirt_road",
      points: [{ x: 6, z: -7.6 }, { x: 10, z: -13 }, { x: 14, z: -16 }],
      width: 3.6,
    },
  ],

  npcs: {
  },

  dialog: {
  },
};
